import $ from "jquery";
import ElementScrollTracker from "./element_scroll_tracker";
import {
  ExperimentTestRecord,
  MouseClickedElementRecord,
  MouseEnteredElementRecord,
  MouseLeftElementRecord,
  MouseMoveEvent,
  PostCameIntoViewEventRecord,
  PostLeftViewEventRecord,
  UnhandledError,
  UserScrolledFeedEventRecord,
} from "./experiment_event";
const autoBind = require("auto-bind");

/**
const interaction_types = [
  "USER_SCROLLED_FEED",
  "USER_SCROLLED_POPUP",
  "USER_SCROLLED_REPLIES",
  "POST_CAME_INTO_VIEW",
  "POST_LEFT_VIEW",
  "POST_REPLIES_OPENED",
  "POST_REPLIES_CLOSED",
  "POST_REPLY_CAME_INTO_VIEW",
  "POST_REPLY_LEFT_VIEW",
  "MOUSE_ENTERED_ELEMENT",
  "MOUSE_LEFT_ELEMENT",
  "MOUSE_CLICKED_ELEMENT",
  "MOUSE_MOVED",
  "UNHANDLED_ERROR",
];
*/

export class UserInteractionTracker {
  constructor(
    serverDriver,
    showHeatmap,
    posts,
    requiredResponsePostIds,
    onRequiredCriteriaMet,
    onAllCriteriaMet,
    onUserReachedBottom,
    onUserLeftBottom,
    onUserScrollIdle
  ) {
    autoBind(this);

    this.tracking = false;
    this.trackMouseMove = false;
    this.batchSize = 100;
    this.currentBatch = [];
    this.batchBuffer = [];
    this.serverDriver = serverDriver;
    this.experimentTestRecord = null;
    this.lastMouseEnteredTimestamp = null;
    this.experimentConfigured = null;
    this.showHeatmap = showHeatmap;
    this.modalPostScrollTracker = null;
    this.mouseMovedCounter = 0;
    this.postingBatch = false;
    this.requiredResponsePostIds = requiredResponsePostIds;
    this.posts = posts;
    this.parentOnRequiredCriteriaMet = onRequiredCriteriaMet;
    this.parentOnAllCriteriaMet = onAllCriteriaMet;
    this.onUserReachedBottom = onUserReachedBottom;
    this.onUserLeftBottom = onUserLeftBottom;
    this.onUserScrollIdle = onUserScrollIdle;

    this.postScrollTracker = null;
    this.modalPostScrollTracker = null;
    this.modalReplyScrollTracker = null;
    this.hasHitBottom = false;
    this.idleValidationTimer = setTimeout(this.onUserScrollIdle, 5000);
    this.processDebugging();
    this.processMouseTracking();
  }

  debugLog(message, ...optionals) {
    if (!this.debugging) return;
    console.debug(message, ...optionals);
  }

  processDebugging() {
    const params = new URLSearchParams(window.location.search);
    this.debugging = params.has("trackingDebug")
      ? params.get("trackingDebug") === "true"
      : false;
  }

  processMouseTracking() {
    const params = new URLSearchParams(window.location.search);
    this.trackMouseMove = params.has("trackMouseMove")
      ? params.get("trackMouseMove") === "true"
      : false;

    this.batchSize = this.trackMouseMove ? 100 : 1;
  }

  startTracking(subjectId, stage, testId) {
    if (this.showHeatmap) {
      this.debugLog(
        "[USER_INTERACTION] - Showing heatmap, so not enabling user interaction tracking"
      );
      return;
    }

    this.debugLog("[USER_INTERACTION] - Starting user interaction tracking");
    this.debugLog("[USER_INTERACTION] - subjectId = " + subjectId);

    this.testStartTimestamp = Date.now();
    this.experimentTestRecord = new ExperimentTestRecord(
      Date.now(),
      subjectId,
      testId,
      this.posts,
      stage
    );
    this._actualStartTracking();
  }

  _actualStartTracking() {
    this.debugLog(
      "[USER_INTERACTION_TRACKER][START_TRACKING] - Registering all event listeners"
    );
    this.tracking = true;

    document.addEventListener("click", this.onMouseClickedElement);
    document.addEventListener("mouseover", this.onMouseEnteredElement);
    document.addEventListener("mouseout", this.onMouseLeftElement);

    window.addEventListener("error", (event) => {
      this.onError(event);
    });
    window.addEventListener("scroll", (event) => {
      this.onUserScrolledFeed(event);
    });
    window.addEventListener("mousemove", (event) => {
      this.onMouseMoved(event);
    });

    let elementScrollTracker = new ElementScrollTracker(
      "div#feedContainer",
      this.onPostCameIntoView,
      this.onPostLeftView
    );

    $(function () {
      elementScrollTracker.trackElements(
        "div#feedContainer > div.post-container"
      );
    });

    this.postScrollTracker = elementScrollTracker;
  }

  stopTracking() {
    if (!this.tracking) {
      return;
    }

    this.tracking = false;
    window.removeEventListener("error", this.onError);
    window.removeEventListener("mousemove", this.onMouseMoved);
    window.removeEventListener("scroll", this.onUserScrolledFeed);
  }

  trackEvent(event) {
    if (!this.tracking) {
      return;
    }

    if (this.postingBatch) {
      this.batchBuffer.push(event);
    } else {
      this.currentBatch.push(event);

      if (this.currentBatch.length >= 100) {
        this.postBatchToServer();
      }
    }
  }

  postBatchToServer() {
    if (this.postingBatch) {
      // Prevent concurrent batch post requests where events come in while the batch is being posted.
      return;
    }

    this.debugLog(
      "[USER_INTERACTION][BATCH] - Posting user interaction batch to server"
    );
    this.batchBuffer = [];
    this.postingBatch = true;

    this.serverDriver
      .putExperimentEventRecords(
        this.currentBatch,
        this.experimentTestRecord.id
      )
      .then((data) => {
        // When we're done posting the batch to the server, swap out the batch buffer and the batch array.
        this.debugLog("Replacing the current batch with the batch buffer");
        this.currentBatch = this.batchBuffer;
        this.batchBuffer = [];
        this.postingBatch = false;
      });
  }

  onUniqueClicked(id) {
    this.debugLog(
      "[USER_INTERACTION][EVENT][MOUSE][UNIQUE_BUTTON] - Got unique button clicked " +
        id
    );
    this.posts[id]["answer"] = "unique";
  }

  onSeenClicked(id) {
    this.debugLog(
      "[USER_INTERACTION][EVENT][MOUSE][SEEN_BUTTON] - Got seen button clicked " +
        id
    );
    this.posts[id]["answer"] = "seen";
  }

  onUserScrolledFeed(event) {
    let thisWindow = $(window);
    let offsetX = thisWindow.scrollLeft();
    let offsetY = thisWindow.scrollTop();
    let timestamp = Date.now();
    let timeOffset = timestamp - this.experimentTestRecord.timestamp;
    let record = new UserScrolledFeedEventRecord(
      timestamp,
      timeOffset,
      offsetX,
      offsetY
    );
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][EVENT][SCROLL][FEED] - Got user scrolled feed event " +
        offsetX +
        ", " +
        offsetY
    );

    if (this.idleValidationTimer != null) {
      clearTimeout(this.idleValidationTimer);
      this.idleValidationTimer = null;
    }

    this.idleValidationTimer = setTimeout(this.onUserScrollIdle, 5000);

    if (
      $(window).scrollTop() + $(window).height() >
      $(document).height() - 100
    ) {
      if (this.hasHitBottom) {
        return;
      } else {
        this.hasHitBottom = true;
        this.onUserReachedBottom();
      }
    } else if (this.hasHitBottom) {
      // We were previously at the bottom and now we aren't anymore.
      this.hasHitBottom = false;
      this.onUserLeftBottom();
    }
  }

  onPostCameIntoView(element, timestamp) {
    let record = new PostCameIntoViewEventRecord(timestamp, element);
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][EVENT][SCROLL][POPUP][POST_CAME_INTO_VIEW] - Got post came into view event " +
        element.id
    );
  }

  onPostLeftView(element, timestampLeft, timestampEntered) {
    this.debugLog(
      "[USER_INTERACTION][EVENT][SCROLL][POPUP][POST_LEFT_VIEW] - Got post left view event " +
        element.id
    );
    let record = new PostLeftViewEventRecord(
      timestampLeft,
      element,
      timestampEntered
    );
    this.trackEvent(record);
  }

  onMouseEnteredElement(event) {
    event.stopPropagation();
    this.lastMouseEnteredTimestamp = Date.now();
    let record = new MouseEnteredElementRecord(
      this.lastMouseEnteredTimestamp,
      event.target
    );
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][EVENT][MOUSE] - Got mouse entered element event",
      event,
      record
    );
  }

  onMouseLeftElement(event) {
    event.stopPropagation();
    let timestampLeft = Date.now();
    let record = new MouseLeftElementRecord(
      timestampLeft,
      event.target,
      this.lastMouseEnteredTimestamp
    );
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][EVENT][MOUSE] - Got mouse left element event",
      event,
      record
    );
  }

  onMouseClickedElement(event) {
    let timestamp = Date.now();
    let record = new MouseClickedElementRecord(timestamp, event.target);
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][EVENT][MOUSE] - Got mouse clicked element event",
      event
    );
  }

  onMouseMoved(event) {
    if (!this.trackMouseMove) return;

    this.mouseMovedCounter += 1;
    if (this.mouseMovedCounter <= 50) return;

    let x = event.pageX;
    let y = event.pageY;
    let timestamp = Date.now();
    let record = new MouseMoveEvent(timestamp, x, y);
    this.trackEvent(record);
  }

  onError(event) {
    let timestamp = Date.now();
    let record = new UnhandledError(
      event.message,
      event.source,
      event.lineno,
      event.colno
    );
    this.trackEvent(record);
    this.debugLog(
      "[USER_INTERACTION][ERROR] - Unhandled error occured during experiment: " +
        message
    );
    this.debugLog(
      "[USER_INTERACTION][ERROR] - Source: " +
        source +
        " -- line number: " +
        event.lineno
    );
    this.debugLog(
      "[USER_INTERACTION][ERROR] - Error was reported to server for debugging"
    );
  }
}
